import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container} from 'react-bootstrap'
import MenuClient from '../components/menus/MenuClient'
import Dashboard from '../pages/client/Dashboard'
import TakeRestaurant from '../pages/client/TakeRestaurant'
import TakeMenu from '../pages/client/TakeMenu'
import Config from '../pages/client/Config'
import Ordersfordelivery from '../pages/client/Ordersfordelivery'
import Ordersdelivered from '../pages/client/Ordersdelivered'
import PayOrder from '../pages/client/PayOrder'
// import PaymentMethods from '../pages/client/PaymentMethods'

export default function ClientRouter () {
	const navigate = useNavigate()

    useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (token === 'undefined') {
			navigate('/login')
		}
    }, [navigate])

	return (
		<Container className="contenido client">
			<MenuClient/>
			<Routes>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/takerestaurant" element={<TakeRestaurant/>}/>
				<Route path="/takemenu/:restaurantid" element={<TakeMenu/>}/>
				<Route path="/pendingorders" element={<Ordersfordelivery/>}/>
				<Route path="/completedorders" element={<Ordersdelivered/>}/>
				<Route path="/config" element={<Config/>}/>
				{/* <Route path="/paymentMethods" element={<PaymentMethods/>}/> */}
				<Route path="/order/:orderId" element={<PayOrder/>}/>
				<Route path="*" element={<NotFoundPage />}/>
			</Routes>
		</Container>
	)
}